import React from "react";
import { SeshTextRawInput } from "./sesh_text_raw_input";

export function SeshTextInput(props: {
	label?: string | JSX.Element;
	help_text?: string | JSX.Element;
	error_text?: string | JSX.Element;
	input_element_override?: JSX.Element;
	input_props: React.HTMLProps<HTMLInputElement>;
}) {
	const input = props.input_element_override ?? (
		<SeshTextRawInput {...props.input_props} />
	);
	return (
		<div className="flex flex-col">
			<div className="field">
				{props.label && <label className="label">{props.label}</label>}
				{props.help_text && (
					<p className="help mb-1">{props.help_text}</p>
				)}
				{input}
				{props.error_text && (
					<p className="help error-text is-pulled-right">
						{props.error_text}
					</p>
				)}
			</div>
		</div>
	);
}
